var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.langList ? _c("main", {
    staticClass: "title"
  }, _vm._l(_vm.langList, function (item, i) {
    return _c("CardItem", {
      key: i,
      attrs: {
        title: item.langName,
        layout: "vertical"
      }
    }, [_vm.type === "textarea" ? [_c("a-textarea", {
      attrs: {
        rows: "5",
        maxLength: 1000
      },
      model: {
        value: _vm.value[item.langId],
        callback: function callback($$v) {
          _vm.$set(_vm.value, item.langId, $$v);
        },
        expression: "value[item.langId]"
      }
    })] : _vm._e(), _vm.type === "input" ? [_c("a-input", {
      attrs: {
        maxLength: 100
      },
      model: {
        value: _vm.value[item.langId],
        callback: function callback($$v) {
          _vm.$set(_vm.value, item.langId, $$v);
        },
        expression: "value[item.langId]"
      }
    })] : _vm._e()], 2);
  }), 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };